import { render, staticRenderFns } from "./RemittanceAdvice.vue?vue&type=template&id=9b943c36&"
import script from "./RemittanceAdvice.vue?vue&type=script&lang=js&"
export * from "./RemittanceAdvice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports